// extracted by mini-css-extract-plugin
export default {"heading":"lL-z","signin":"mL-z","signupBtn":"nL-z","disabled":"oL-z"};